import React from 'react';
import Markdown from 'react-markdown';
import './style.scss';

export const mapSectionHeading = (sectionData) =>
  sectionData
    ? {
        sectionName: sectionData.section_name,
        title: sectionData.section_title,
        text: sectionData.section_description,
      }
    : null;

function SectionHeading({ section, sectionData }) {
  return (
    section && (
      <div className='tb__content pb-10'>
        {section.sectionName && <p className='p2 uppercase'>{section.sectionName}</p>}
        {sectionData ? (
          <Markdown>{section.title}</Markdown>
        ) : (
          <h1 className='whitespace-pre-line'>{section.title}</h1>
        )}
        {section.text && <p className='whitespace-pre-line p2'>{section.text}</p>}
      </div>
    )
  );
}

export default SectionHeading;
